import { dateToString } from "utils/dateUtils";
import { getAsync as _getAsync, addAsync as _addAsync } from "../../api";

const BASE_URL = "/general/pending-payments";

function normalizePendingPaymentData(data) {
    const { lastPaymentDate: lastPaymentDateInMillis, clientFirstName, clientMiddleName, clientLastName } = data;

    const lastPaymentDate = lastPaymentDateInMillis && new Date(lastPaymentDateInMillis);

    return {
        ...data,
        lastPaymentDate,
        lastPaymentDateString: dateToString(lastPaymentDate),
        clientFullName: `${clientFirstName} ${clientMiddleName} ${clientLastName}`,
    };
}

export function normalizePendingPayments(tasks) {
    return tasks.map((d) => normalizePendingPaymentData(d));
}

export async function getAllAsync() {
    return _getAsync({ url: BASE_URL, normalizer: normalizePendingPayments });
}

export async function sendEmailAsync({ payload }) {
    return _addAsync({ url: `${BASE_URL}/send-email`, data: payload });
}

export async function sendSMSAsync({ payload }) {
    return _addAsync({ url: `${BASE_URL}/send-sms`, data: payload });
}